import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './firebase';
import imageCompression from 'browser-image-compression';

export const storageService = {
  // Upload image with compression
  uploadImage: async (file, path, onProgress = null) => {
    try {
      // Compress image
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1920,
        useWebWorker: true
      };

      const compressedFile = await imageCompression(file, options);

      // Create storage reference
      const storageRef = ref(storage, `${path}/${Date.now()}_${file.name}`);

      // Upload file
      const uploadTask = uploadBytesResumable(storageRef, compressedFile);

      return new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (onProgress) onProgress(progress);
          },
          (error) => {
            reject(error);
          },
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            resolve({
              url: downloadURL,
              path: uploadTask.snapshot.ref.fullPath
            });
          }
        );
      });
    } catch (error) {
      throw error;
    }
  },

  // Upload file (for videos and other non-image files)
  uploadFile: async (file, path, onProgress = null) => {
    try {
      // Create storage reference
      const storageRef = ref(storage, `${path}/${Date.now()}_${file.name}`);

      // Upload file without compression
      const uploadTask = uploadBytesResumable(storageRef, file);

      return new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (onProgress) onProgress(progress);
          },
          (error) => {
            reject(error);
          },
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            resolve({
              url: downloadURL,
              path: uploadTask.snapshot.ref.fullPath
            });
          }
        );
      });
    } catch (error) {
      throw error;
    }
  },

  // Delete image
  deleteImage: async (imagePath) => {
    try {
      const imageRef = ref(storage, imagePath);
      await deleteObject(imageRef);
    } catch (error) {
      throw error;
    }
  },

  // Upload multiple images
  uploadMultipleImages: async (files, path, onProgress = null) => {
    try {
      const uploadPromises = files.map((file, index) =>
        storageService.uploadImage(file, path, (progress) => {
          if (onProgress) {
            onProgress(index, progress);
          }
        })
      );

      return await Promise.all(uploadPromises);
    } catch (error) {
      throw error;
    }
  }
};
